import Crypto from '@/util/crypto'
import { convertObj } from '@/util'
import { filterForwardedForLocalIp } from '@/util/forwarded-ip'

// import { RSAENCRY } from '@/util/RSAEncryption'
//const aeskey = 'liuhuan123456789'

function getSign(params = {}, uuid, timestamp) {
  const queryString = `${timestamp}${convertObj(params, true)}`.replace(/[+]/g, '-').replace(/\//g, '_') // TODO：正则处理
  console.log(queryString, 'queryString')
  console.log('uuid:', uuid)
  return Crypto.getMd5(Crypto.encrypt(queryString, uuid))
}

function setBuff(app) {
  if (process.client) {
    return app.$TURINGOFFRONT['Clouse'](app.store.state.app.uuid)
  } else {
    // console.log('加密前: ', app.store.state.app.uuid)
    return app.$TURINGOFEND['Clouse'](app.store.state.app.uuid)
  }
}

// plugins/axios.js 文件
export default async ({ $axios, app, redirect }) => {
  let cfg = {}
  const errorBury = (params) => {
    if (!params.config) params.config = cfg
    if (params) {
      const obj = {
        buryEventId: 'UM_Event_WebRequestError',
        buryParams: {
          UM_Key_IP: params.config?.headers?.['http_x_forwarded_for'] || null,
          UM_Key_RequestUrl: `${params.config?.baseURL || ''}${params.config?.url || ''}` || null,
          UM_Key_RequestMethod: params.config?.method || null,
          UM_Key_RequestData: JSON.stringify(params.config?.data) || null,
          UM_Key_RequestParams: JSON.stringify(params.config?.params) || null,
          UM_Key_RequestConfig: JSON.stringify(params.config) || null,
          UM_Key_RequestCurrentTime: JSON.stringify(params.config?.headers?.currentTime) || null,
          UM_Key_ResponseStatus: JSON.stringify(params.status) || null,
          UM_Key_Response: params.data ? JSON.stringify(params.data) : params.request?.responseText || null,
          UM_Key_ErrMsg: params.statusText || params.errorMsg || null,
          is_client: process.client || null
        }
      }
      if (process.client) {
        app.$LokBury.handleMD(obj, 'custom')
      } else {
        obj.buryParams = {
          ...obj.buryParams,
          referer: params.config.headers?.common?.referer || null,
          UA: params.config.headers?.common?.['user-agent'] || null
        }
        app.$ServerBury(obj)
      }
    }
  }
  // 基本配置
  $axios.defaults.timeout = 10000
  $axios.defaults.withCredentials = false
  // $axios.defaults.baseURL = process.env.BASE_URL || 'http://alpha-web-api.netpop.app'
  $axios.defaults.baseURL = process.env.BASE_URL || 'https://test-web-api.netpop.app'
  // $axios.defaults.baseURL = process.env.BASE_URL || 'https://web-api.netpop.app'

  // 请求拦截器
  $axios.onRequest((config) => {
    console.log('请求前:' + config.url)
    console.log(config)
    if (config.tvHeaders) {
      // config.headers.token = config.tvHeaders.token
      // config.headers.clientType = config.tvHeaders.clientType
      // config.headers.deviceid = config.tvHeaders.deviceid
      config.headers = {
        ...config.headers,
        ...config.tvHeaders
      }
    }
    // if (
    //   process.server &&
    //   config.headers &&
    //   !config.headers['http_forwarded_ip']
    // ) {
    //   config.headers['http_forwarded_ip'] = global['x-forwarded-for'] || 'none'
    // }
    // 阿里云计算会把用户真实ip放在请求头里  字段名：x-forwarded-for
    // java服务端需要传来源ip字段为： http_x_forwarded_for
    if (process.server) {
      const forwardedFor = config?.headers?.common?.['x-forwarded-for']
      console.log('请求前ip:', JSON.stringify(forwardedFor))
      if (forwardedFor) {
        //192.168.137.118, 172.23.62.171, 127.0.0.1, 45.148.10.59, 100.120.108.74, 8.219.217.152, 160.250.203.202
        const filteredForwardedFor = filterForwardedForLocalIp(forwardedFor)
        if (filteredForwardedFor) {
          config.headers['http_x_forwarded_for'] = filteredForwardedFor
        } else {
          delete config.headers['http_x_forwarded_for']
        }
      }
    }
    config.headers['Content-Type'] = 'application/json'
    config.headers['lang'] = app.i18n.locale
    if (!config.tvHeaders) {
      app.store?.state?.user?.token && (config.headers['token'] = app.store.state.user.token)
    }
    const timestamp = new Date().getTime()
    config.headers['currentTime'] = timestamp
    config.headers['sign'] = getSign(config.method === 'post' ? config.data : config.params, app.store?.state?.app?.uuid, timestamp)
    config.headers['aesKey'] = setBuff(app)
    cfg = JSON.parse(JSON.stringify(config))
    // console.log('请求拦截器, url:', config.url, config.headers, config.params || config.data)
    return config
  })

  // 响应拦截器
  $axios.onResponse((response) => {
    // if (response.config.method == 'post' && process.client) {
    //response.data = JSON.parse(Crypto.decrypt(response.data.data, app.store?.state?.app?.uuid))
    // }
    const res = response.data
    // console.log('---------', response.config.url)
    if (res.code === '00000') {
      try {
        if (!res.data) {
          return res.data
        }
        let jsonStr = Crypto.decrypt(res.data, app.store?.state?.app?.uuid)
        console.log('pageUrl:' + app.router.currentRoute.path)
        console.log('响应后:' + response.config.url)
        console.log('解密数据:' + jsonStr)
        return JSON.parse(jsonStr)
      } catch (e) {
        return res.data
      }
      // console.log('接口内容获取成功: url,res:', response.config.url, JSON.stringify(res.data, null, 2))
    } else if (res.code == 'A0230') {
      errorBury(response)
      //goLogin()
      app.store.commit('user/SET_TOKEN', '')
    } else {
      if (response.config.url === '/sitemap/sitemap_all.xml') {
        // 获取sitemap 直接返回xml 无res.code
        return res
      } else {
        errorBury(response)
        // console.error('服务端报错：url,response', response.config, response.config.url, res)
        console.error('服务端报错：url', response.config.url)
        return Promise.reject(new Error(res || 'Error'))
      }
    }
  })

  $axios.onError((error) => {
    errorBury(error.response || { errorMsg: error.message })
    const code = parseInt(error.response && error.response.status)
    console.log('接口调用出错', error.message)
    if (code === 404 || code === 500) {
      return Promise.reject({ code, msg: error.response.statusText })
      // redirect("/404");
    }
    return Promise.reject('error')
  })
}
